export function hashString(string) {
    let hash = 0, chr;

    if (string.length === 0) return hash;

    for (let i = 0; i < string.length; i++) {
        chr = string.charAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0;
    }

    return hash;
}


export const hexToRGB = (hex) => {

    switch (hex) {
        case '#800000':
            return 'rgb(128, 0, 0)'
    }
}
